export default {
  VUE_APP_ENABLE_BATCH_BUY: true, // 是否启用批量购买订阅，带有单引号和不带单引号都会设备为boolean类型
  VUE_APP_ENABLE_PAY: true, // 是否开启支付功能
  defaultYear: localStorage.getItem('defaultYear'),
  invStepMode: {
    0: '待开票',
    1: '开票中',
    2: '作废',
    3: '作废中',
    4: '重开',
    5: ''
  },
  invoiceTypeMode: {
        0: "电子普通发票",
        1: "纸质普通发票",
        2: "增值税专票",
        4: "数电专票",
        5: "数电普票",
      },
}
